import http from "./http-common";
import { getAuthToken } from "./authService";

const getAlert = async () => {
  const response = await http.get("/api/v1/alerts");
  return response.data;
};

const updateAlert = async (message) => {
  const token = await getAuthToken();
  const response = await http.put(
    "/api/v1/alerts",
    { message },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

const AlertService = {
  getAlert,
  updateAlert,
};

export default AlertService;
